import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { Observable } from 'rxjs';

import { ResponseReportCriteria, SurveyReportCriteria } from '@shared/models/report.model';
import { BaseService } from '@shared/services/base.service';
import { metricsReporting } from '@shared/utils/metrics-util';

@Injectable()
export class TaskAssignmentReportService extends BaseService {
  public headers: HttpHeaders;

  constructor(
    private readonly http: HttpClient,
    protected readonly logger: NGXLogger
  ) {
    super();
    this.envService = this.env.services.exportReport;
    this.headers = new HttpHeaders(this.envService.headers);
  }

  responseExportReport(criteria: ResponseReportCriteria): Observable<any> {
    const url = this.getFullUrl(this.envService.response, null, true);
    const metrics = metricsReporting([this.envService.response]);

    return this.http.post<any>(url, criteria, {
      headers: this.loaderHeaders(0, metrics),
      observe: 'body'
    });
  }

  surveyExportReport(criteria: SurveyReportCriteria): Observable<any> {
    const url = this.getFullUrl(this.envService.survey, null, true);
    const metrics = metricsReporting([this.envService.response]);

    return this.http.post<any>(url, criteria, {
      headers: this.loaderHeaders(0, metrics),
      observe: 'body'
    });
  }
}
